'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _controller = require('./controller');

var _controller2 = _interopRequireDefault(_controller);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  restrict: 'E',
  bindings: {},
  template: '<div ng-include="$ctrl.tpl"></div>',
  controller: _controller2.default

  // WEBPACK FOOTER //

}; // import template from './template.html';


/** WEBPACK FOOTER **
 ** ./client/app/modules/products/components/material-pricing/index.js
 **/